import { useReframe } from 'nike-re-framejs';
import React, { useContext } from 'react';

import { fireGAEvent } from '@/analytics';
import { EventCashinOffers } from '@/cashins/views/CashinOffers';
import { denormalizeSportEventId } from '@/nikeone/domain/sportevent';
import { TipCell, TipRow, TipTable } from '@/nikeone/NikeOneCommon';
import { navigate } from '@/routing';
import { TURBO_LIVE_MATCH_DETAIL } from '@/routing/routes';
import { HybridScoreboard } from '@/scoreboards/views/LiveScoreboard';
import { MainBetTlv } from './MainBet';
import { trackingPropsForSportEvent } from '@/common/tracking';
import BetLocationContext, { betLocation } from 'nike-ui/src/common/BetLocationContext';
import { match$$ } from 'nike-ui/src/components/turboLive/push/overview/subs';
import { isVideoStream } from 'nike-ui/src/components/turboLive/push/overview/handlers';
import { getSportNameById } from 'nike-ui/src/common/utils/utils';

function LiveMatch({ matchId, streamsOnlyView }) {
    const betLocationContext = useContext(BetLocationContext);
    const derefSub = useReframe();
    const eventId = denormalizeSportEventId(matchId);
    const event = eventId && derefSub(match$$(null, String(eventId)));
    const sportName = getSportNameById(event?.get('sportId'));
    const setLiveProvider = betLocationContext?.betLocationSection?.id === betLocation.KURZY_OVERVIEW_PREMATCH.id;

    if (streamsOnlyView) {
        if (!isVideoStream(event)) {
            return null;
        }
    }

    function goToDetail(e, eventName) {
        e.preventDefault();
        e.stopPropagation();
        fireGAEvent('Ponuka', eventName, 'Zapas');
        navigate(
            TURBO_LIVE_MATCH_DETAIL,
            {
                sportName: sportName,
                matchId: eventId
            },
            undefined,
            { fromNikeOne: true }
        );
    }

    return (
        <div
            data-atid="nikeone-match"
            className="nikeone-match nikeone-match-live flex flex-col"
            {...trackingPropsForSportEvent(event)}
        >
            <HybridScoreboard matchId={String(eventId)} sportId={event?.get('sportId')} goToDetail={goToDetail} />
            <div data-atid="tip-container" className="tips-container">
                {setLiveProvider ? (
                    <BetLocationContext.Provider value={{ betLocationSection: betLocation.KURZY_OVERVIEW_LIVE }}>
                        <MainBetTlv eventId={matchId} goToDetail={goToDetail} />
                    </BetLocationContext.Provider>
                ) : (
                    <MainBetTlv eventId={matchId} goToDetail={goToDetail} />
                )}
            </div>
            <EventCashinOffers eventId={matchId} />
        </div>
    );
}

export default LiveMatch;

export const LiveFakeMatch = () => (
    <div data-atid="nikeone-match" className="nikeone-match nikeone-match-live">
        <div className="nikeone-match-header">
            <div className="super radius10 wave-animation" />
            <div className="score">
                <div className="event-data radius10 wave-animation">&nbsp;</div>
            </div>
        </div>
        <TipTable>
            <TipRow>
                <TipCell classes="wave-animation radius10" />
            </TipRow>
        </TipTable>
    </div>
);
